<template>
	<div class="map-bg bg-green-800 min-h-screen h-full w-full">
		<div style="position: relative; z-index: 1;">
			<div class="gradient-bg px-4 md:px-10 lg:px-32 xl:px-64 pt-6 pb-8">
				<h1 class="title text-white text-6xl sm:text-7xl md:text-8xl">LOST IN THE CITY</h1>
			</div>

			<div class="fixed bottom-0 left-0 w-full bottom-shadow">
				<error class="px-4 md:px-10 lg:px-32 xl:px-64" colour="red" icon="triangle_error" title="You're offline" body="Please check your internet connection and reload the app." />
			</div>
		</div>
	</div>
</template>

<style>
.gradient-bg {
	background: rgb(50,63,67);
	background: linear-gradient(180deg, rgba(50,63,67,1) 0%, rgba(50,63,67,1) 55%, rgba(50,63,67,0) 97%, rgba(50,63,67,0) 100%);
}
.title {
	line-height: 0.9;
	text-shadow: 0 3px 25px rgba(70, 83, 87, 0.6);
}
.bottom-shadow {
	box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.45);
}
</style>

<script>
import Storages from 'js-storage';
import ErrorBox from '../components/ErrorBox.vue';

export default {
	name: 'Offline',
	path: '/offline',
    props: ['path'],
	components: {
		'error': ErrorBox
	},
	data() {
		return {
			welcome_alert: null
		}
	},
	created() {
        if (window.navigator.onLine === true) {
            this.online();
        }

		window.addEventListener('online',  this.online);
	},
    methods: {
        online() {
			window.location.replace("/" + this.path);
        }
    }
}
</script>
